export default "__VITE_ASSET__b94d51ec__"